import { connect } from "react-redux";
import { getSelf } from "./redux/selectors";
import UserInfo from "./userInfo";
const mapStateToProps = (state) => ({
    user: getSelf(state)
});
export default connect(mapStateToProps)(UserInfo);
